import { Navigate } from "react-router-dom";

function ProtectedAdminRoute({ children }) {
  const isLoggedIn = localStorage.getItem("adminLoggedIn");

  if (!isLoggedIn) {
    return <Navigate to="/adminLogin" replace />;
  }

  return children;
}

export default ProtectedAdminRoute;
